import Icon from 'veui/components/Icon'

Icon.register({
  'magnifier-minus': {
    paths: [
      {
        d: 'M726.63 681.37L599.79 554.53a320 320 0 00-474.06-428.8 320 320 0 00428.8 474.06l126.84 126.84a32 32 0 0045.26-45.26zM352 608a256 256 0 11181-75 254.33 254.33 0 01-181 75zm160-256a32 32 0 01-32 32H224a32 32 0 010-64h256a32 32 0 0132 32z'
      }
    ],
    width: '768',
    height: '768'
  }
})
